import script from "./PanierView.vue?vue&type=script&setup=true&lang=js"
export * from "./PanierView.vue?vue&type=script&setup=true&lang=js"

import "./PanierView.vue?vue&type=style&index=0&id=269891af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-269891af"]])

export default __exports__